import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { MdFace } from "react-icons/md";
import { FaTshirt, FaWheelchair } from "react-icons/fa";
import { GiBlackBelt, GiConverseShoe, GiSnorkel, GiTrousers } from "react-icons/gi";
import React from "react";
import { getAllCharacterSkinVariantNames, getAllSkinClassNames } from "./spineHelper";
import { Arrays } from "../../shared/helper/Arrays";
import { runInAction } from "mobx";
export let SelectionConstrain;

(function (SelectionConstrain) {
  SelectionConstrain[SelectionConstrain["Any"] = 0] = "Any";
  SelectionConstrain[SelectionConstrain["ExactlyOne"] = 1] = "ExactlyOne";
  SelectionConstrain[SelectionConstrain["MinimumOne"] = 2] = "MinimumOne";
  SelectionConstrain[SelectionConstrain["MaximumOne"] = 3] = "MaximumOne";
})(SelectionConstrain || (SelectionConstrain = {}));

const skinAccessoires = "Accessoires";
export class CharacterSelectionHelper {
  /**
   * Toggled the assigned variant of the assigned class and considered the selections constraints of the class.
   * @param char The character to toggle on.
   * @param variantsOfAnimation All available variantNames of the animation and class.
   * @param skinClassName The class name of the variant.
   * @param skinVariantName The variant name to toggle.
   */
  static constrainedToggle(char, variantsOfAnimation, skinClassName, skinVariantName) {
    const skinIsSelected = char.isSkinActive(skinClassName, skinVariantName);
    const classConstrain = CharacterSelectionHelper.ClassNameToConstrain.get(skinClassName);
    const activeCount = variantsOfAnimation.filter(variantName => char.isSkinActive(skinClassName, variantName)).length;

    if (classConstrain === SelectionConstrain.ExactlyOne) {
      if (skinIsSelected && activeCount == 1) return;
      char.removeAllSkins(skinClassName);
    }

    if (classConstrain === SelectionConstrain.MinimumOne && skinIsSelected && activeCount == 1) return;

    if (classConstrain === SelectionConstrain.MaximumOne) {
      if (!skinIsSelected && activeCount == 1) {
        char.removeAllSkins(skinClassName);
      }
    }

    char.toggleSkins(skinClassName, skinVariantName);
  }

  static randomizeSkinSelection(skins, character) {
    runInAction(() => {
      character.resetSkins(true);
      const skinClassNames = getAllSkinClassNames(skins);
      skinClassNames === null || skinClassNames === void 0 ? void 0 : skinClassNames.forEach(skinClassName => {
        const classConstrain = CharacterSelectionHelper.ClassNameToConstrain.get(skinClassName);

        if (classConstrain) {
          // only apply skins with constraints
          const skinVariantNames = getAllCharacterSkinVariantNames(skins, skinClassName, true);
          const randomVariant = Arrays.randomItem(skinVariantNames);
          character.toggleSkins(skinClassName, randomVariant);
        }
      });
      this.selectRandomAccessoires(skins, character, 0, 4);
    });
  }

  static selectRandomAccessoires(skins, character, minCount, maxCount) {
    const skinVariantNames = getAllCharacterSkinVariantNames(skins, skinAccessoires, true);
    const count = Math.min(skinVariantNames.length, minCount + Math.floor(Math.random() * (maxCount - minCount)));

    for (let i = 0; i < count; i++) {
      const randomIndex = Math.floor(Math.random() * skinVariantNames.length);
      const skin = skinVariantNames[randomIndex];
      character.toggleSkins(skinAccessoires, skin);
      skinVariantNames.splice(randomIndex, 1);
    }
  }

}

_defineProperty(CharacterSelectionHelper, "ClassNameToIcon", new Map([["Köpfe", /*#__PURE__*/React.createElement(MdFace)], ["Koepfe", /*#__PURE__*/React.createElement(MdFace)], ["Oberbekleidung", /*#__PURE__*/React.createElement(FaTshirt)], ["Unterbekleidung", /*#__PURE__*/React.createElement(GiTrousers)], ["Schuhe", /*#__PURE__*/React.createElement(GiConverseShoe)], ["Taucherausrüstung", /*#__PURE__*/React.createElement(GiSnorkel)], [skinAccessoires, /*#__PURE__*/React.createElement(GiBlackBelt)], ["Rollstühle", /*#__PURE__*/React.createElement(FaWheelchair)]]));

_defineProperty(CharacterSelectionHelper, "ClassNameToConstrain", new Map([["Köpfe", SelectionConstrain.ExactlyOne], ["Koepfe", SelectionConstrain.ExactlyOne], ["Unterbekleidung", SelectionConstrain.MinimumOne], ["Oberbekleidung", SelectionConstrain.MinimumOne], ["Schuhe", SelectionConstrain.MaximumOne], ["Rollstühle", SelectionConstrain.ExactlyOne]]));